import React from "react";
import { useTranslation } from "react-i18next";

const DOCOnlineLanguageForm = ({
  index,
  otherLanguage,
  onDelete,
  docOnline,
  setDocOnline,
  languages,
  languageLevels,
  errors
}) => {
  const { t } = useTranslation();

  function onChange({ target }, index) {
    let _otherLanguages = [...docOnline.otherLanguages];

    if (
      target.name === "languageId" &&
      (_otherLanguages
        .map((lang) => lang.languageId)
        .indexOf(Number(target.value)) > -1 ||
        docOnline.motherLanguage === Number(target.value))
    )
      return;

    _otherLanguages[index][target.name] = Number(target.value);

    setDocOnline({
      ...docOnline,
      otherLanguages: _otherLanguages
    });
  }

  return (
    <div className="others" style={index > 0 ? { marginTop: "-20px" } : { marginTop: "0px" }}>
      <div className="form-group lang-edit">
        {index === 0 && (
          <div className="label-wrapper">
            <label>{t("Other language")}</label>
          </div>
        )}
        <div className="select-wrapper" style={{ display: "flex", flexDirection: "column", alignItems: "baseline"}}>
          {errors.otherLanguages !== undefined &&
            errors.otherLanguages[index] !== undefined &&
            errors.otherLanguages[index].languageId && (
              <span className="error-msg">
                {errors.otherLanguages[index].languageId}
              </span>
            )}
          <select
            className="form-select"
            name="languageId"
            id="languageId"
            onChange={(event) => onChange(event, index)}
            value={otherLanguage.languageId || 0}
          >
            <option key={0} selected disabled value={0}>
              {t("Add Language")}
            </option>
            {languages.map((item, index) => (
              <option key={index} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="form-group level-edit">
        {index === 0 && (
          <div className="label-wrapper">
            <label>{t("Language level")}</label>
          </div>
        )}
        <div className="select-wrapper"  style={{ display: "flex", flexDirection: "column", alignItems: "baseline"}} >
          {errors.otherLanguages !== undefined &&
            errors.otherLanguages[index] !== undefined &&
            errors.otherLanguages[index].languageLevelId && (
              <span className="error-msg">
                {errors.otherLanguages[index].languageLevelId}
              </span>
            )}
          <select
            className="form-select"
            name="languageLevelId"
            onChange={(event) => onChange(event, index)}
            value={otherLanguage.languageLevelId}
          >
            <option key={0} selected disabled value={0}>
              {t("Add Language Level")}
            </option>
            {languageLevels.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>
      </div>
      {index >= 0 && (
        <div className="form-group delete-button-edit">
          <button
            key={index}
            type="button"
            className="app-button btn-second btn-md"
            id="delete-otherlanguage"
            onClick={() => onDelete(index)}
          >
            {t("delete")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DOCOnlineLanguageForm;
